import { copy } from 'angular';
var History3ProductsService = (function () {
    function History3ProductsService() {
        this.history = [];
        this.historySessionKey = 'history-3-products';
        var sessionStorageValue = sessionStorage.getItem(this.historySessionKey);
        this.history = sessionStorageValue === null ? [] : JSON.parse(sessionStorageValue);
    }
    History3ProductsService.prototype.push = function (devices) {
        if (devices === void 0) { devices = []; }
        if (devices.length === 0) {
            return;
        }
        this.history.push(copy(devices));
        sessionStorage.setItem(this.historySessionKey, JSON.stringify(this.history));
    };
    History3ProductsService.prototype.get = function () {
        return copy(this.history);
    };
    History3ProductsService.prototype.getLast = function () {
        return copy(this.history[this.history.length - 1]);
    };
    History3ProductsService.prototype.clear = function () {
        this.history.length = 0;
        sessionStorage.setItem(this.historySessionKey, JSON.stringify(this.history));
    };
    History3ProductsService.$inject = [];
    return History3ProductsService;
}());
export { History3ProductsService };
